<template>
    <!-- 对接详情发言 -->
    <div class="DockingDetailsCenterDialogue">
        <!-- 对接详情发言Title -->
        <DockingSystemTitle :title="'发言'" :underlineType="true" :moreType="false" :titleCenter="true" />
        <div class="content">
            <!-- 多行文本框 -->
            <el-input class="input" type="textarea" :rows="11" placeholder="请输入您的留言..." v-model="textarea"></el-input>
            <div class="button">
                <span class="submit" @click="submitMsg">提交</span>
            </div>
            <!-- 对接详情留言 -->
            <div class="comment">
                <!-- <DockingDetailsCenterComment :userType="false"/>
            <DockingDetailsCenterComment :userType="true"/> -->

                <div class="DockingDetailsCenterComment">
                    <div class="content" v-for="(item,index) in speakList" :key="index">
                        <div class="top">
                            <div class="img">
                                <img src="../../../../public/static/images/honoredGuest1.png" alt="">
                            </div>

                            <div class="msg">

                                <p class="name">
                                    {{item.realname}} 小秘书
                                    <span v-show="userType">我的</span>
                                </p>
                                <p class="time">
                                    {{item.create_time}}
                                </p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="text">
                                {{item.content}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //对接详情发言Title
    import axios from "axios"
    export default {
        props: {
            id: String
        },
        components: {
            DockingSystemTitle,

        },
        data() {
            return {
                textarea: '',
                speakList: [],
                userId:'',//用户id
                userType:false,//暂留的我的是否显示
            }
        },
        watch: {
            id(val) {
                this.userId = val;
                //赋值用户id
                this.getSpeak(val);
            }
        },
        created: function () {

        },
        methods: {
            submitMsg() {
                let self = this;
                //获取云对接详情
                axios.post('/api/jointactivitymessagesave', {
                    id:self.userId,
                    content: self.textarea,
                })
                    .then(function (response) {
                        if (response.data.code == 0) {
                            alert('提交成功')
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            getSpeak(id) {
                let self = this;
                //获取云对接详情
                axios.get('/api/jointactivitymessagelist', {
                    params: {
                        id: id
                    }
                })
                    .then(function (response) {
                        if (response.data.code == 0) {
                            self.speakList = response.data.data;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
        },

    }
</script>

<style scoped>
    @media (max-width: 768px) {

        /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
        .DockingDetailsCenterDialogue {
            margin-left: 0px !important;
        }

        .DockingDetailsCenterDialogue .content {
            margin: 0 15px;
            margin-top: 20px;
        }
    }

    .DockingDetailsCenterDialogue {
        margin-top: 40px;
        background-color: #1d1d1f;
        border-radius: 25px;
        margin-left: 7px;
        margin-bottom: 38px;
    }

    .content {
        margin: 0 32px;
        margin-top: 35px;
    }

    .input {
        background-color: #f7f7f8;
        border-radius: 10px;

        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
    }

    .button {
        margin-top: 21px;
    }

    .submit {
        display: inline-block;
        padding: 20px 56px;
        background-color: #f957fd;
        border-radius: 5px;

        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #ffffff;
    }

    .comment {
        margin-top: 50px;
    }

    /* 留言内容 */

    @media (max-width: 768px) {

        /* .div{
    margin-left: 10px;
    margin-right: 10px;
  } */
        .DockingDetailsCenterComment .content {
            padding-top: 20px;
        }
    }

    .content {
        padding-top: 40px;
        border-top: 1px solid #dcdcdc;
    }

    .top {
        display: flex;
        justify-content: left;
    }

    .img {
        width: 86px;
        height: 86px;
        border-radius: 50%;
    }

    .img img {
        width: 100px;
        height: 100%;
    }

    .msg {
        margin-left: 16px;
    }

    .name {
        margin-top: 15px;

        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #ffffff;
    }

    .name>span {
        padding: 2px 8px;
        border-radius: 3px;
        border: solid 1px #c9c9c9;

        font-size: 10px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 1px;
        color: #b5b5b7;
    }

    .time {
        margin-top: 10px;

        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 0px;
        color: #b5b5b7;
    }

    .bottom {
        margin-top: 31px;
        padding-bottom: 42px;
    }

    .text {

        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 29px;
        letter-spacing: 0px;
        color: #ffffff;
    }
</style>